<svg width="71" height="71" viewBox="0 0 71 71" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M68.5 2.5L18.5 2.5C9.66344 2.5 2.5 9.66345 2.5 18.5L2.5 68.5" stroke="white" stroke-width="5" stroke-linecap="square"/>
</svg>
